import { Component, DestroyRef, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { GlobalConstants } from './common/global';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { NavigationBarComponent } from './layout/navigation-bar/navigation-bar.component';
import { GdprModalComponent } from './components/gdpr-modal/gdpr-modal.component';
import { LoaderComponent } from './components/loader/loader.component';
import { FooterComponent } from './layout/footer/footer.component';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

declare var _paq: any;

@Component({
  selector: 'app-root',
  templateUrl: `./app.component.html`,
  styleUrls:  [`shared/styles/app.${environment.page}.component.sass`],
  standalone: true,
  imports: [NavigationBarComponent, GdprModalComponent, LoaderComponent, RouterModule, FooterComponent, CommonModule]
})
export class AppComponent {
  envConnId = environment.connId;
  public isUserLoggedIn = false;
  isHomeRoute: boolean = false;

  constructor(
    private http: HttpClient, 
    private renderer: Renderer2,
    private titleService: Title,
    private readonly router: Router,
    private readonly destroyRef: DestroyRef
    ) {}

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef)).subscribe((navigationEnd: NavigationEnd) => {
      const cleanPath = navigationEnd.urlAfterRedirects.split(/[?#]/)[0];
      this.isHomeRoute = cleanPath === '/' || cleanPath === '';
    });

    this.titleService.setTitle(environment.pageTitle);
    this.setFavicon(`img/favicons/${environment.page}.ico`);

    if(environment.pageFolder === 'sport') {
     const body = document.body;
     const backgroundImageUrl = `url(img/${environment.page}/bg-2.jpg)`;
     this.renderer.setStyle(body, 'background-image', backgroundImageUrl);
    }

    /* if(localStorage.getItem(''accessTokenCentral' + environment.connId')) {
      this.refreshToken();
    }  */
    if(localStorage.getItem('accessToken' + environment.connId)) {
      GlobalConstants.isAuth = true;
      this.isUserLoggedIn = true;
      //this.refreshCentralToken();
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //matomo
        if (typeof _paq !== 'undefined') {
          _paq.push(['setCustomUrl', event.urlAfterRedirects]);
          _paq.push(['setDocumentTitle', document.title]);
          _paq.push(['trackPageView']);
        }

        window.scrollTo(0, 0);
      }
    });
  }

  refreshCentralToken() {
    const httpOptions = {    
      withCredentials: true,
    };   
  
    this.http.post<any>(`${environment.apiUrl}/auth/main/refresh`, {}, httpOptions ).subscribe({
      next: data => {
        localStorage.setItem('accessToken' + environment.connId, data.token);
      },
      error: error => {
        //console.log(error, "refresh Token error");
      }
    })
  }

  refreshToken() {
    const httpOptions = {    
      withCredentials: true,
    };    

    this.http.post<any>(`${environment.apiUrl}/auth/refresh/${this.envConnId}`, {}, httpOptions ).subscribe({
      next: data => {
        //localStorage.setItem("'accessTokenCentral' + environment.connId", data.accessToken);
      },
      error: error => {
      }
    })
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  setFavicon(faviconUrl: string) {
    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = faviconUrl;
    
    const existingLink = document.querySelector("link[rel*='icon']");
    if (existingLink) {
      this.renderer.removeChild(document.head, existingLink);
    }
    this.renderer.appendChild(document.head, link);
  }
}